import store from '@/store';
import {
  GROUP_CHAT_MEMBER_ROLE,
  GROUP_CHAT_ROLE_PERMISSIONS_MAP,
  CHAT_GROUP_PERMISSION,
} from '_lib/constants/group-chat';

class ChatGroupPermission {
  constructor() {}
  judge(keyName, userInfo) {
    if (!userInfo) {
      userInfo = store.getters.cur_group_chat.my_chat_group_info;
    }
    const myRole = userInfo.group_role;
    const rolePermissionMap =
      store.getters.cur_group_chat?.permission?.role_permission ??
      GROUP_CHAT_ROLE_PERMISSIONS_MAP;
    const groupRolePermission = rolePermissionMap[myRole] ?? 0;
    return Boolean(groupRolePermission & CHAT_GROUP_PERMISSION[keyName]);
  }
}

export default new ChatGroupPermission();
